import React from 'react';
import PropTypes from 'prop-types';
import Link from '../link/link';

const GetDirections = ({ latitude, longitude }) => {
  const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;

  return (
    <div>
      <Link
        to={googleMapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Get directions on Google Maps"
      >
        Get Directions
      </Link>
    </div>
  );
};

GetDirections.propTypes = {
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
};

export default GetDirections;
